import MODULES from './moduleDefinitions'

const calculateTotal = ({ activeModules = {}, partner = null } = {}) => {

    const activeSlugs = Object.keys(activeModules).filter((slug) => activeModules[slug] === true)

    // Combo-pakketten éérst: exacte-match op de billable modules geeft een
    // vaste pakket-prijs (i.p.v. fixedPackage + extras opgeteld).
    if (Array.isArray(partner?.packages)) {
        const freeModules = partner.freeIncludedModules || []
        const activeNonFree = activeSlugs.filter((slug) => !freeModules.includes(slug))

        const matchingPackage = partner.packages.find((pkg) => {
            if (!Number.isFinite(pkg.price)) return false
            if (pkg.modules.length !== activeNonFree.length) return false
            return pkg.modules.every((slug) => activeNonFree.includes(slug))
        })

        if (matchingPackage) {
            return matchingPackage.price
        }
    }

    if (partner?.fixedPackage && Number.isFinite(partner.fixedPackage.price)) {

        const packageSlugs = partner.fixedPackage.modules
        const allPackageModulesActive = packageSlugs.every((slug) => activeSlugs.includes(slug))

        if (allPackageModulesActive) {
            // Extras = actieve modules die NIET in het pakket zitten EN niet in
            // freeIncludedModules. Free modules zijn al inbegrepen in de
            // pakket-prijs (bv. FIX = housevisits-pakket €30 + personas gratis).
            const freeModules = partner.freeIncludedModules || []
            const extraSlugs = activeSlugs.filter((slug) =>
                !packageSlugs.includes(slug) && !freeModules.includes(slug)
            )
            const extraTotal = extraSlugs.reduce((sum, slug) => sum + (MODULES[slug]?.price || 0), 0)
            return partner.fixedPackage.price + extraTotal
        }

    }

    const freeModules = partner?.freeIncludedModules || []
    const billableSlugs = activeSlugs.filter((slug) => !freeModules.includes(slug))

    return billableSlugs.reduce((sum, slug) => sum + (MODULES[slug]?.price || 0), 0)

}

export default calculateTotal
